/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RealizedDimensionLine
 */
export interface RealizedDimensionLine {
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionLine
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionLine
     */
    dimensionDisplayName?: string;
    /**
     * 
     * @type {number}
     * @memberof RealizedDimensionLine
     */
    realizedDelta?: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedDimensionLine
     */
    netAppliedDelta?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RealizedDimensionLine
     */
    scoreApplied?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealizedDimensionLine
     */
    currentScoreBefore?: number;
    /**
     * 
     * @type {number}
     * @memberof RealizedDimensionLine
     */
    currentScoreAfter?: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionLine
     */
    priorDataSource?: string;
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionLine
     */
    dataSource?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RealizedDimensionLine
     */
    alreadyRealized?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionLine
     */
    skippedReason?: string;
}

/**
 * Check if a given object implements the RealizedDimensionLine interface.
 */
export function instanceOfRealizedDimensionLine(value: object): value is RealizedDimensionLine {
    return true;
}

export function RealizedDimensionLineFromJSON(json: any): RealizedDimensionLine {
    return RealizedDimensionLineFromJSONTyped(json, false);
}

export function RealizedDimensionLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealizedDimensionLine {
    if (json == null) {
        return json;
    }
    return {
        
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'dimensionDisplayName': json['dimensionDisplayName'] == null ? undefined : json['dimensionDisplayName'],
        'realizedDelta': json['realizedDelta'] == null ? undefined : json['realizedDelta'],
        'netAppliedDelta': json['netAppliedDelta'] == null ? undefined : json['netAppliedDelta'],
        'scoreApplied': json['scoreApplied'] == null ? undefined : json['scoreApplied'],
        'currentScoreBefore': json['currentScoreBefore'] == null ? undefined : json['currentScoreBefore'],
        'currentScoreAfter': json['currentScoreAfter'] == null ? undefined : json['currentScoreAfter'],
        'priorDataSource': json['priorDataSource'] == null ? undefined : json['priorDataSource'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'alreadyRealized': json['alreadyRealized'] == null ? undefined : json['alreadyRealized'],
        'skippedReason': json['skippedReason'] == null ? undefined : json['skippedReason'],
    };
}

export function RealizedDimensionLineToJSON(json: any): RealizedDimensionLine {
    return RealizedDimensionLineToJSONTyped(json, false);
}

export function RealizedDimensionLineToJSONTyped(value?: RealizedDimensionLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimensionKey': value['dimensionKey'],
        'dimensionDisplayName': value['dimensionDisplayName'],
        'realizedDelta': value['realizedDelta'],
        'netAppliedDelta': value['netAppliedDelta'],
        'scoreApplied': value['scoreApplied'],
        'currentScoreBefore': value['currentScoreBefore'],
        'currentScoreAfter': value['currentScoreAfter'],
        'priorDataSource': value['priorDataSource'],
        'dataSource': value['dataSource'],
        'alreadyRealized': value['alreadyRealized'],
        'skippedReason': value['skippedReason'],
    };
}

